import { IACCommunication } from '..';
import { IACUsecase } from '../iacType/iacUsecase';
import { IACMessageData } from '../transport/iacProtocol';

/*
 * Current Interface documentation:
 * https://wiki.1and1.org/Ihapps/IacToolbarInterface#Data_structure
 *
 * TODO  check with the navigator team the differences between the
 * current interface documentation and implementation:
 *
 *  1) Could not find 'background' in the docs?
 *  2) 'usecase' should be only an IACUseCase and not a string?
 */
export interface ToolbarUseCase {
  id: number;
  usecase: string | IACMessageData;
  args: any[];
  caller_app: string;
  caller_version: string;
  background?: boolean;
}

export class Toolbar {

  public static iacUsecaseFactory(eventData: ToolbarUseCase): IACUsecase {
    let iacUsecase: IACUsecase;

    if (typeof eventData.usecase === 'string') {

      iacUsecase = IACCommunication.createUsecase(eventData.usecase);
      iacUsecase.protocol.setSender('toolbar');
      iacUsecase.setPayload.apply(iacUsecase, eventData.args);
      // eslint-disable-next-line no-extra-boolean-cast
      iacUsecase[!!eventData.background ? 'asRPE' : 'asRPC']();

    } else {
      // Okay, the given use case is defined with IAC 4.0.0 protocol.
      iacUsecase = IACCommunication.createUsecaseFromConfig(eventData.usecase);
    }

    return iacUsecase;
  }

}
